import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import { Printer } from "@phosphor-icons/react";
import { api, roomUrl, adminHeaders } from "@/lib/api";

export default function PrintPage() {
    const { roomId } = useParams();
    const [room, setRoom] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        api.get(`/rooms/${roomId}`)
            .then((res) => setRoom(res.data))
            .catch(() => setNotFound(true));
    }, [roomId]);

    if (notFound) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="print-not-found">
                <p className="text-sm text-muted-foreground">Ruangan tidak ditemukan.</p>
            </div>
        );
    }

    if (!room) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="print-loading">
                <p className="text-sm text-muted-foreground">Memuat...</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-10" data-testid="print-label">
            <button
                data-testid="print-button"
                onClick={() => {
                    window.print();
                    // otomatis tandai QR sudah diprint (mode admin)
                    api.patch(`/admin/rooms/${roomId}/status`, { field: "qr_printed", value: true }, { headers: adminHeaders() }).catch(() => {});
                }}
                className="no-print mb-10 bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-[#9c4a2a] transition-colors flex items-center gap-2"
            >
                <Printer size={18} weight="bold" /> Cetak Label
            </button>

            <div className="w-full max-w-md border-2 border-stone-900 p-10 flex flex-col items-center text-center">
                <img src="/logo.png" alt="INERRE interior" className="h-14 object-contain mb-8" data-testid="print-logo" />
                <p className="text-[10px] tracking-[0.3em] uppercase font-bold text-stone-500" data-testid="print-property-name">
                    {room.property_name}
                </p>
                <h1 className="font-serif text-4xl sm:text-5xl tracking-tighter leading-none font-medium mt-2 mb-8" data-testid="print-room-name">
                    {room.name}
                </h1>
                <div className="bg-white p-2 border border-stone-900" data-testid="print-qr">
                    <QRCode value={roomUrl(room.id)} size={220} />
                </div>
                {room.short_code && (
                    <p className="mt-4 font-mono text-sm tracking-[0.3em] font-medium" data-testid="print-short-code">
                        KODE: {room.short_code}
                    </p>
                )}
                <p className="mt-6 text-xs text-stone-500 leading-relaxed max-w-[260px]">
                    Pindai untuk rendering ruangan, gambar ME / electrical, dan submission service — atau masukkan kode di aplikasi supervisor / admin
                </p>
            </div>
        </div>
    );
}
